export const sliderAnimation = {
    duration: 400,
    easing: (t: number): number =>
        t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
};

// linear easing required for seamless continuous auto-scroll
export const autoScrollAnimation = {
    duration: 20000,
    easing: (t: number): number => t,
};
